import { Children, cloneElement } from "react";

import { TabScrollButtonProps } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import MuiTabs, { TabsProps as MuiTabsProps } from "@mui/material/Tabs";

import { useMediaQueries } from "../../shared";
import SegmentedToggleButtons from "./SegmentedToggleButtons";
import { useStyles } from "./styles";
import { SEGMENTED_TOGGLE_TAB_SIZES } from "./types";

interface SegmentedToggleProps {
  children: React.JSX.Element | React.JSX.Element[];
  size: SEGMENTED_TOGGLE_TAB_SIZES;
  tabWidth?: string;
  fullWidth?: boolean;
}

const SegmentedToggle = ({
  children,
  size,
  tabWidth,
  fullWidth,
  ...props
}: SegmentedToggleProps & Omit<MuiTabsProps, "children">) => {
  const { toMd } = useMediaQueries();
  const {
    childrenCSS,
    mainTabsCSS,
    scrollButtonLeftMargin,
    scrollButtonRightMargin,
    segmentedToggleButtons
  } = useStyles(size, tabWidth, fullWidth);

  const CustomScrollButton = (props: TabScrollButtonProps) =>
    SegmentedToggleButtons(
      scrollButtonLeftMargin,
      scrollButtonRightMargin,
      segmentedToggleButtons,
      props
    );

  return (
    <MuiTabs
      {...props}
      variant="scrollable"
      allowScrollButtonsMobile
      slots={{
        scrollButtons: CustomScrollButton
      }}
      sx={
        [
          mainTabsCSS,
          {
            width: toMd ? "calc(100% - 10px)" : undefined,
            "& .MuiTabs-scroller": {
              width: toMd ? "calc(100% - 10px)" : undefined
            }
          }
        ] as SxProps<Theme> | undefined
      }
    >
      {Children.map(children, child =>
        cloneElement(child, {
          sx: childrenCSS
        })
      )}
    </MuiTabs>
  );
};

export default SegmentedToggle;
